<template>
  <section>
    <Title :title-name="title.MessagesList.titleName" :title-link="title.MessagesList.titleLink" />
    <div class="messages_list">
      <div class="select_service index">
        <div v-for="mess in Cmtpax" :key="mess.id" style="margin: 14pt 0">
          <div :class="'block-item bgRead' + mess.has_read">
            <div class="container">
              <router-link :to="{ name: 'MessageDetail', query: { secret: secret, msgId: mess.id } }">
                <div class="row">
                  <div class="item-icon col-2">
                    <i class="sb_mobile sb_message text-right">
                      <i v-if="mess.has_read > 0" class="badge badge-pill badge-danger" style="font-size: 9pt">{{
                        mess.has_read
                      }}</i>
                    </i>
                  </div>
                  <div class="item-title col-9">
                    <span v-html="replaceMessage(mess.content)"></span>
                    <span v-if="mess.content.length > 20">...</span>
                  </div>
                  <div class="col-1 bullet_right"><i class="fa fa-chevron-right" aria-hidden="true"></i></div>
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import '@/assets/scss/modules/MessagesList.scss'
import { mapGetters } from 'vuex'
import Title from '@/components/Title/index'

export default {
  name: 'MessagesList',
  components: { Title },
  props: {
    secret: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      pageTitle: 'Your Messages'
    }
  },
  computed: {
    ...mapGetters({
      Cmtpax: 'MessagesList/Cmtpax'
    })
  },
  mounted() {
    this.$store.dispatch('MessagesList/getCmtpax')
  },
  methods: {
    replaceMessage(v) {
      return v.substr(0, 20)
    }
  }
}
</script>
